import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Wrapper,
  Card,
  IconWrapper,
  Title,
  Subtitle,
  StyledButton,
  BtnContainer,
} from "./styles";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { useUserStore } from "../../../../../store/user";

export const ProfileSetup: React.FC = () => {
  const navigate = useNavigate();
  const { clearUser } = useUserStore();

  const handleLogout = () => {
    clearUser();
    navigate("/login");
  };

  // const handleSelectProfile = () => {
  //   navigate("/select-profile");
  // };

  return (
    <Wrapper>
      <Card>
        <IconWrapper>
          <EngineeringIcon />
        </IconWrapper>
        <Title>Seu perfil está sendo preparado</Title>
        <Subtitle>
          Nossa equipe está trabalhando na configuração inicial da sua conta.
          Isso pode levar alguns minutos. Você será notificado assim que estiver
          pronto.
        </Subtitle>
        <BtnContainer>
          <StyledButton onClick={handleLogout}>
            Voltar para o Login
          </StyledButton>
          {/* {profiles && (
            <StyledButton onClick={handleSelectProfile}>
              Selecionar perfil
            </StyledButton>
          )} */}
        </BtnContainer>
      </Card>
    </Wrapper>
  );
};
